import { Calendar, Dumbbell } from "lucide-react";

const navigation = {
  main: [
    {
      key: "planner",
      label: "Planificador",
      icon: <Calendar size={18} strokeWidth={1.7} />,
      to: "/planner/new",
      activePath: "/planner",
    },
    {
      key: "programs",
      label: "Mis rutinas",
      icon: <Dumbbell size={18} strokeWidth={1.7} />,
      to: "/programs",
    },
  ],
  account: [],
};

export default navigation;
